import { useEffect } from "react";

// Keeps the mobile screen awake while `active` is true using the
// Screen Wake Lock API. Auto re-acquires the lock when the tab returns
// to the foreground (the browser releases it on visibilitychange).
//
// Browsers without the API (older iOS Safari < 16.4) silently no-op —
// nothing breaks, the screen just sleeps as usual.
export const useWakeLock = (active) => {
    useEffect(() => {
        if (!active) return undefined;
        if (typeof navigator === "undefined" || !("wakeLock" in navigator)) {
            return undefined;
        }

        let sentinel = null;
        let cancelled = false;

        const acquire = async () => {
            try {
                sentinel = await navigator.wakeLock.request("screen");
                sentinel.addEventListener("release", () => {
                    sentinel = null;
                });
            } catch {
                /* user gesture missing or permission blocked – noop */
            }
        };

        const onVisibility = () => {
            if (document.visibilityState === "visible" && !sentinel && !cancelled) {
                acquire();
            }
        };

        acquire();
        document.addEventListener("visibilitychange", onVisibility);

        return () => {
            cancelled = true;
            document.removeEventListener("visibilitychange", onVisibility);
            if (sentinel) {
                sentinel.release().catch(() => {});
                sentinel = null;
            }
        };
    }, [active]);
};
